/**
 * The link never reached the customer.
 *
 * Loud on purpose. The row is otherwise indistinguishable from a healthy
 * reservation, so without this a CSR taking a "my link never arrived" call has
 * no way to tell which case they are in.
 *
 * THE REMEDY IS PER-STAGE (BON-472). It used to say "use Resend link" on every
 * row that had ever failed to send, including the ones where that button is
 * greyed out — and a reservation whose email failed and which nobody paid for
 * reaches that state as a matter of course. The instruction sent a CSR to click
 * a dead control and work the real answer out of a tooltip.
 */
import type { ReservationStage } from '../../api/reservations';

import { sendFailedNote } from './reservationSendFailure';

export function ReservationSendFailedNote({ stage }: { stage: ReservationStage }) {
  return (
    <div className="mt-1 text-xs font-semibold text-red-600 dark:text-red-400">
      {/* Resend is on this very row, so the recoverable case can point straight
          at it rather than naming another screen. */}
      {sendFailedNote(stage, true)}
    </div>
  );
}
